// Provider logos for the connect buttons (ConnectButton's `logo`). Inline SVG, decorative (the button's words carry
// the name). Provider brand colours are allowed here and nowhere else (components/kit/README.md, rule 6).
import { CalendarDays, FileSpreadsheet } from "lucide-react";

const svg = { "aria-hidden": true, focusable: false } as const;

export function GoogleLogo() {
  return (
    <svg {...svg} width="22" height="22" viewBox="0 0 48 48">
      <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.6l6.8-6.8C35.8 2.4 30.3 0 24 0 14.6 0 6.6 5.4 2.7 13.3l7.9 6.2C12.5 13.6 17.8 9.5 24 9.5z" />
      <path fill="#4285F4" d="M46.1 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.4c-.5 2.9-2.2 5.3-4.6 6.9l7.4 5.8c4.3-4 6.9-9.9 6.9-17.2z" />
      <path fill="#FBBC05" d="M10.5 28.6c-.5-1.4-.8-3-.8-4.6s.3-3.2.8-4.6l-7.9-6.2C1 16.5 0 20.1 0 24s1 7.5 2.7 10.7l7.8-6.1z" />
      <path fill="#34A853" d="M24 48c6.5 0 11.9-2.1 15.9-5.8l-7.4-5.8c-2.1 1.4-4.8 2.3-8.5 2.3-6.2 0-11.5-4.1-13.4-9.8l-7.9 6.1C6.6 42.6 14.6 48 24 48z" />
    </svg>
  );
}

export function MicrosoftLogo() {
  return (
    <svg {...svg} width="20" height="20" viewBox="0 0 22 22">
      <rect x="1" y="1" width="9.5" height="9.5" fill="#F25022" />
      <rect x="11.5" y="1" width="9.5" height="9.5" fill="#7FBA00" />
      <rect x="1" y="11.5" width="9.5" height="9.5" fill="#00A4EF" />
      <rect x="11.5" y="11.5" width="9.5" height="9.5" fill="#FFB900" />
    </svg>
  );
}

export function WhatsAppLogo() {
  return (
    <svg {...svg} width="22" height="22" viewBox="0 0 32 32">
      <path fill="#25D366" d="M16 3C8.8 3 3 8.7 3 15.8c0 2.5.7 4.9 2 7L3 29l6.4-2c2 1.1 4.3 1.7 6.6 1.7 7.2 0 13-5.7 13-12.8S23.2 3 16 3z" />
      <path fill="#fff" d="M22.6 19.2c-.3-.2-2-1-2.3-1.1-.3-.1-.5-.2-.8.2-.2.3-.9 1.1-1.1 1.3-.2.2-.4.2-.7.1-.3-.2-1.4-.5-2.7-1.7-1-.9-1.7-2-1.9-2.3-.2-.3 0-.5.1-.7l.5-.6c.2-.2.2-.4.3-.6.1-.2 0-.4 0-.6l-1-2.5c-.3-.7-.6-.6-.8-.6h-.7c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.8s1.2 3.3 1.4 3.5c.2.2 2.4 3.7 5.9 5.1 2.9 1.1 3.5.9 4.1.9.6-.1 2-.8 2.3-1.6.3-.8.3-1.5.2-1.6-.1-.1-.3-.2-.7-.4z" />
    </svg>
  );
}

export function MetaLogo() {
  return (
    <svg {...svg} width="24" height="24" viewBox="0 0 32 32">
      <path fill="#0866FF" d="M6.4 20.6c0 1.2.3 2.2.7 2.8.5.8 1.3 1.2 2.1 1.2 1 0 1.9-.2 3.7-2.7 1.4-2 3.1-4.8 4.2-6.6l1.9-3c1.3-2 2.9-4.3 4.7-5.9C25.2 5.2 26.8 4.6 28.4 5c1.9.5 3.2 2.1 3.5 4.4.4 3.1-.4 7.3-2.4 11-1.6 3-3.6 4.4-5.6 4.4-1.6 0-2.9-.8-4.6-3.1-.9-1.3-2-3.2-3.1-5.2l.1-.2-1.7 2.7c-2.3 3.6-3.8 5.8-6.7 5.8-2.2 0-4-1-5-2.7-.8-1.4-1.2-3.2-1.2-5.2 0-3.6 1-7.3 2.8-10.1C6 4.1 8 3 10.1 3c1.3 0 2.6.4 3.9 1.4l-1.8 2.9c-.8-.7-1.6-1-2.4-1-1 0-2 .7-2.9 2-.9 1.5-1.6 3.6-1.6 5.8v6.5z" />
    </svg>
  );
}

export function HubSpotLogo() {
  return (
    <svg {...svg} width="22" height="22" viewBox="0 0 32 32">
      <path fill="#FF7A59" d="M23.6 11.3V7.9a2.5 2.5 0 0 0 1.4-2.2 2.5 2.5 0 1 0-5 0c0 1 .6 1.8 1.4 2.2v3.4a7.1 7.1 0 0 0-3.4 1.5L8.9 6.9a2.8 2.8 0 1 0-1.3 1.7l8.9 6.9a7.1 7.1 0 0 0 .1 8l-2.7 2.7a2.3 2.3 0 1 0 1.6 1.6l2.7-2.7a7.1 7.1 0 1 0 5.4-13.8zm-1.1 10.7a3.6 3.6 0 1 1 0-7.3 3.6 3.6 0 0 1 0 7.3z" />
    </svg>
  );
}

export function PipedriveLogo() {
  return (
    <svg {...svg} width="22" height="22" viewBox="0 0 32 32">
      <circle cx="16" cy="16" r="15" fill="#017737" />
      <path fill="#fff" d="M13.2 25.5h-2.6V11c0-.6 0-1.2-.1-1.7h2.4l.2 1.3c.9-1.1 2.3-1.7 3.8-1.7 3.2 0 5.3 2.6 5.3 6.2 0 3.7-2.2 6.3-5.4 6.3-1.4 0-2.7-.5-3.6-1.4v5.5zm3.1-14.1c-1.8 0-3.2 1.4-3.2 4 0 2.4 1.3 4 3.2 4 1.9 0 3.1-1.5 3.1-4.1 0-2.4-1.2-3.9-3.1-3.9z" />
    </svg>
  );
}

export function BufferLogo() {
  return (
    <svg {...svg} width="22" height="22" viewBox="0 0 32 32">
      <path fill="currentColor" d="M16 3 3 9.4l13 6.4 13-6.4L16 3zm-9 10.9-4 2 13 6.4 13-6.4-4-2-9 4.4-9-4.4zm0 6.3-4 2L16 29l13-6.4-4-2-9 4.4-9-4.4z" />
    </svg>
  );
}

export function CsvLogo() {
  return <FileSpreadsheet size={24} strokeWidth={1.75} aria-hidden="true" focusable="false" />;
}

export function CalendarLogo() {
  return <CalendarDays size={24} strokeWidth={1.75} aria-hidden="true" focusable="false" />;
}
